module.exports = __webpack_public_path__ + "img/erweima.31f9e3ea.jpg";